module.exports = __webpack_public_path__ + "img/kapelusze.112f0ea9.jpeg";